// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/GamificationGoals/index.css
// module id = 2515
// module chunks = 0